// chakra-theme.js
import { extendTheme } from '@chakra-ui/react';

const customTheme = extendTheme({
    fonts: {
        body: "'Plus Jakarta Sans', 'Mukta', sans-serif",
        heading: "'Plus Jakarta Sans', 'Mukta', sans-serif",
    },
});

export default customTheme;
